import React, { useEffect, useState } from 'react';
import { CheckCircle2, CalendarCheck, UserCheck, Mail } from 'lucide-react';
import { formatMoney } from './calc';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ConfirmationScreen = ({ bookingId }) => {
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/bookings/${bookingId}`)
      .then((r) => r.json())
      .then(setBooking)
      .catch(() => {});
  }, [bookingId]);

  return (
    <div className="confirmation-screen" data-testid="confirmation-screen">
      <div className="confirmation-icon"><CheckCircle2 size={56} strokeWidth={1.5} /></div>
      <h2 className="confirmation-title">Booking Confirmed!</h2>
      {booking && (
        <p className="confirmation-number" data-testid="confirmation-number">
          Confirmation #{booking.booking_number}
        </p>
      )}
      <p className="confirmation-sub">
        Thank you{booking ? `, ${booking.customer_name.split(' ')[0]}` : ''}! Your payment was
        successful and your cleaning is booked.
      </p>

      {booking && (
        <div className="confirmation-items">
          {booking.items.map((item, idx) => (
            <div key={idx} className="confirmation-item" data-testid={`confirmation-item-${idx}`}>
              <div className="confirmation-item-info">
                <strong>{item.service_label}</strong>
                <span>{item.address}</span>
                <span>{item.date} • {item.time_window}</span>
              </div>
              <span className="confirmation-item-price">{formatMoney(item.total)}</span>
            </div>
          ))}
          <div className="confirmation-total">
            <span>Total Paid</span>
            <span>{formatMoney(booking.total)}</span>
          </div>
        </div>
      )}

      <div className="confirmation-next">
        <h3>What happens next?</h3>
        <div className="confirmation-next-item">
          <Mail size={18} strokeWidth={1.5} />
          <span>You'll receive an email receipt shortly</span>
        </div>
        <div className="confirmation-next-item">
          <UserCheck size={18} strokeWidth={1.5} />
          <span>We assign one of our vetted cleaning professionals to your booking</span>
        </div>
        <div className="confirmation-next-item">
          <CalendarCheck size={18} strokeWidth={1.5} />
          <span>Your cleaner arrives during your selected window on the scheduled day</span>
        </div>
      </div>

      <a href="/" className="btn btn-primary" data-testid="confirmation-home-btn">Back to Home</a>
    </div>
  );
};

export default ConfirmationScreen;
